import { useState } from 'react';
import { api } from '../lib/api';
import { USD } from '../lib/format';
import { useAsync } from '../lib/useAsync';
import { C, EASE_SPRING } from '../lib/theme';
import { RecoveredModal } from './RecoveredModal';
import { IconTrendUp } from './icons';
import { originFrom, type Origin } from './ScaleModal';

/**
 * Botão de destaque no header — verde, "flutuando" acima da barra por causa
 * da sombra elevada (não `position:fixed`; mora no fluxo do header, ao lado
 * de Motivos/avatar, pra ficar visível em toda tela, não só na Fila como o
 * `FalsePositiveButton`). Sempre visível mesmo sem recuperação nenhuma no
 * período — é destaque positivo, não alerta condicional.
 */
export function RecoveredButton({ period }: { period: { from?: string; to?: string; channel?: string } }) {
  const [origin, setOrigin] = useState<Origin | null>(null);
  const [open, setOpen] = useState(false);
  const recovered = useAsync(() => api.recovered(period), [open, period.from, period.to, period.channel]);
  const total = Number(recovered.data?.kpis.total_valor ?? 0);

  return (
    <>
      <button
        type="button"
        onClick={(e) => { setOrigin(originFrom(e)); setOpen(true); }}
        title="Recuperados no período — faturas vencidas pagas + churns e contractions que reassinaram"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 8, border: '1px solid rgba(46,204,113,0.45)',
          background: 'linear-gradient(150deg, rgba(46,204,113,0.22), rgba(39,174,96,0.14))',
          borderRadius: 99, padding: '8px 16px 8px 12px', cursor: 'pointer', font: 'inherit',
          color: C.green, boxShadow: '0 10px 24px -10px rgba(46,204,113,0.55)',
          transition: `transform 0.2s ${EASE_SPRING}, box-shadow 0.2s`,
        }}
      >
        <IconTrendUp size={15} />
        <span style={{ fontSize: 12.5, fontWeight: 750, letterSpacing: '0.005em' }}>Recuperados</span>
        {total > 0 && (
          <span style={{
            fontSize: 11.5, fontWeight: 800, color: '#0C2115', background: C.green,
            borderRadius: 99, padding: '2px 8px', fontVariantNumeric: 'tabular-nums',
          }}>{USD(total)}</span>
        )}
      </button>

      <RecoveredModal open={open} origin={origin} onClose={() => setOpen(false)} period={period} />
    </>
  );
}
